import i18n from "i18next"
import {initReactI18next} from "react-i18next"

import Backend from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'


let resources = {
    en: {},
    pl: {},
    ua: {},
    hu: {},
}

i18n.use(initReactI18next)
    .use(Backend)
    .use(LanguageDetector)
    .init({
        resources,
        detection: {
            order: ['querystring', 'cookie', 'localStorage', 'sessionStorage'],
        },
        lng: localStorage.getItem("setLanguage") || "pl",          //default language
        fallbackLng: localStorage.getItem("setLanguage") || "pl",  //when specified language translations not present
        interpolation: {
            escapeValue: true,
        },
        react: {
            useSuspense: true,
        }
    })

export default i18n
